<template>
    <div>
        <header class="g-hd f-bcf">
            <img class="back" @click="backward()" src="../../assets/jxwx/arr_02.png" alt=""> {{data.name | nameP}}医生{{name}}明细
        </header>
        <!-- <ul class="performanceBox f-dfsb">
            <li class="f-tal">
                <div class="tt f-fs2 f-cl1">本月绩效累计(元)</div>
                <div class="f-fs8">{{data.MonthFee | moneyP}}</div>
            </li>
            <li class="f-tar">
                <div class="tt f-fs2 f-cl1">昨日绩效(元)</div>
                <div class="f-cl2 f-fs8">{{data.todayMoney | moneyP}}</div>
            </li>
        </ul> -->
        <ul v-if="this.name == '诊查费' || this.name == '检查开单' || this.name == '手术费' " class="m-detailsList f-bcf">
            <li>
                <div class="itemName">患者姓名</div>
                <div class="cumMonth">项目名称</div>
                <div class="yesPer">
                    <div>价格</div>
                </div>
            </li>
            <li v-for="item in details" :key="item.id">
                <div class="itemName">{{item.NAME}}</div>
                <div class="cumMonth">{{item.TARITEMDESC }}</div>
                <div class="yesPer">
                    <div class="f-cl2">{{item.PRICE | moneyP}}</div>
                </div>
            </li>
        </ul> 
        <ul v-if="this.name == '收住院'" class="m-detailsList f-bcf">
            <li>
                <div class="itemName">开单科室</div>
                <div class="cumMonth">接收科室</div>
                <div class="yesPer">
                    <div>患者数量</div>
                </div>
            </li>
            <li v-for="item in details" :key="item.id">
                <div class="itemName">{{item.RESDEPDESC}}</div>
                <div class="cumMonth">{{item.RECDEPDESC}}</div>
                <div class="yesPer">
                    <div class="f-cl2">{{item.AMOUNT}}</div>
                </div>
            </li>
        </ul> 
        <ul v-if="this.name == '单项统计'" class="m-detailsList f-bcf">
            <li>
                <div class="itemName">患者姓名</div>
                <div class="cumMonth">项目名称</div>
                <div class="yesPer">
                    <div>价格</div>
                </div>
            </li>
            <li v-for="item in details" :key="item.id">
                <div class="itemName">{{item.NAME}}</div>
                <div class="cumMonth">{{item.ENTRYNAME }}</div>
                <div class="yesPer">
                    <div class="f-cl2">{{item.PRICE | moneyP}}</div>
                </div>
            </li>
        </ul> 
        <ul v-if="this.name == '检查相关'" class="m-detailsList f-bcf">
            <li>
                <div class="itemName">患者姓名</div>
                <div class="cumMonth">项目名称</div>
                <div class="yesPer">
                    <div>数量</div>
                </div>
            </li>
            <li v-for="item in details" :key="item.id">
                <div class="itemName">{{item.NAME}}</div>
                <div class="cumMonth">{{item.ENTRYNAME }}</div>
                <div class="yesPer">
                    <div class="f-cl2">{{item.AMOUNT}}</div>
                </div>
            </li>
        </ul> 
        

    </div>
</template>

<script>
import api from "@/axios/api";
export default {
    data() {
        return {
            name: this.$route.query.name,
            date: this.$route.query.date,
            data: this.$route.query.data,
            details:[]
        };
    },
    filters: {
        nameP: function(value) {
            if (value) {
                return value.split("(")[0];
            }
        }
    },
    mounted() {
        switch (this.name) {
            case "诊查费":
                this.getExaminationDetails("1");
                break;
            case "检查开单":
                this.getExaminationDetails("2");
                break;
            case "手术费":
                this.getExaminationDetails("3");
                break;
            case "检查相关":
                this.getCheckRelated();
                break;
            case "收住院":
                this.getNumberOfInpatientDetails();
                break;
            case "单项统计":
                this.getSingleFee();
                break;
        }
    },
    methods: {
        backward() {
            this.$router.backward();
            // alert(this.$route.params.isBack)
        },
        //获取医生核算子分类明细
        getExaminationDetails(type) {
            let par = {
                docId: this.data.docId,
                today: this.date,
                type: type
            };
            api.getExaminationDetails(par).then(res => {
                this.details = res.result.details;
            });
        },
        //获取医生检查相关明细
        getCheckRelated() {
            let par = {
                docId: this.data.docId,
                today: this.date
            };
            api.getCheckRelated(par).then(res => {
                this.details = res.result.details;
            });
        },
        //获取医生收住院明细
        getNumberOfInpatientDetails() {
            let par = {
                docId: this.data.docId,
                today: this.date
            };
            api.getNumberOfInpatientDetails(par).then(res => {
                this.details = res.result.details;
            });
        },
        //获取医生单项奖励明细
        getSingleFee() {
            let par = {
                docId: this.data.docId,
                today: this.date
            };
            api.getSingleFee(par).then(res => {
                this.details = res.result.feeDetailsDetails;
            });
        }
    }
};
</script>

<style lang="less" scoped>
.g-hd {
    display: flex;
    align-items: center;
    height: 13.3vw;
    margin: 0 4.8vw;
    border-bottom: 1px solid #dedede;
    .back {
        width: 2vw;
        font-size: 16px;
        margin-right: 2.6vw;
    }
    .tt {
        margin-left: 4vw;
    }
}
.performanceBox {
    margin: 0 4.8vw;
    padding: 3.2vw 0 1.8vw 0;
    li {
        padding: 1.3vw 0;
        .tt {
            margin-bottom: 2.6vw;
        }
    }
}
.m-detailsList {
    
    li {
        position: relative;
        display: flex;
        align-items: center;
        height: 14.5vw;
        margin: 0 4vw;
        font-size: 15px;
        border-bottom: 1px solid #dedede;
        div {
            flex: 1;
            text-align: center;
        }
        .itemName {
            text-align: left;
        }
        .yesPer {
            text-align: right;
            div {
                display: inline-block;
                width: 20vw;
            }
        }
    }
    li:first-child {
        margin: 0;
        height: 10.9vw;
        padding: 0 4vw;
        background-color: #fafcff;
        font-size: 13px;
        color: #a6a6a6;
        // border-top: 1px solid #d4e5ff;
         border-bottom: 1px solid #d4e5ff;
        .itemName {
            padding-left: 2px;
        }
    }
    li:last-child {
        border-bottom: none;
    }
}
.itemBox {
    padding-bottom: 3.3vw;
}
.itemDetails {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 9.3vw;
    margin: 0 4vw 2vw 4vw;
    padding: 0 6vw;
    background: #f7f7f7;
    background-color: 6px;
    font-size: 14px;
    div {
        flex: 1;
        text-align: center;
    }
    div:first-child {
        text-align: left;
    }
    .yesPer {
        div {
            float: right;
            width: 16vw;
            text-align: center;
        }
    }
}
.van-tabs {
    /deep/.van-tab {
        font-size: 16px;
    }
    /deep/.van-tabs__wrap {
        border-bottom: 1px solid #dedede;
    }
    /deep/.van-tab--active {
        color: #e5323b;
    }
    /deep/.van-tabs__line {
        width: 7.2vw !important;
    }
    .box {
        padding: 5vw 0 5vw 4vw;
        background-color: #fff;
    }
}
</style>





// WEBPACK FOOTER //
// src/jxwx/components/chargeItemDetails.vue